import { ReactNode } from 'react';
import { PageContainer } from '@/components/layout';

interface AdminLayoutProps {
  children: ReactNode;
  /** Page title - no longer used, kept for API compat */
  title?: string;
  /** Producer ID - no longer used, kept for API compat */
  producerId?: string;
  /** Producer name - no longer used, kept for API compat */
  producerName?: string;
  /** Use wider container */
  wide?: boolean;
}

/**
 * Simplified AdminLayout that only provides PageContainer.
 * AppShell is now rendered by UnifiedAppLayout - this component
 * exists for API compatibility with existing pages.
 */
export function AdminLayout({
  children,
  wide = true,
}: AdminLayoutProps) {
  return (
    <PageContainer maxWidth={wide ? 'full' : 'xl'}>
      {children}
    </PageContainer>
  );
}
